import React from 'react';
import { useQuery, Loading, Error} from 'react-admin';
import moment from 'moment'
import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();

const ViewDetails = ({records, ftype}) =>{
    var tags= []; 
    //console.log(records)
    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'recertificatedetails',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            filter: {rcid: records.id },
            sort: { field: 'id', order: 'ASC' }
        }
    });
 
    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;

    tags.push(
        data.map(record => (
            <tr >
                <td style={{fontWeight:'bold'}}> {record.proced} </td>
                <td>{record.read_date && moment(record.read_date).format('MM/DD/yyyy')} </td>
                <td>{record.emp_init} </td>
                <td>{record.emp_init_date && moment(record.emp_init_date).format('MM/DD/yyyy')} </td>
            </tr>
        ))
    )
    
   // console.log(tags)
    return (
        <>{tags}</>
    )
                
}

export default ViewDetails